var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_5032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 1C11.3179 1 1 11.3179 1 24C1 36.6812 11.3179 47 24 47C36.6812 47 47 36.6812 47 24C47 11.3179 36.6831 1 24 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7665 0 0 10.7665 0 24C0 37.2326 10.7665 48 24 48C37.2326 48 48 37.2326 48 24C48 10.7665 37.2345 0 24 0ZM29.9686 24.8449H26.064V38.7619H20.2781C20.2781 38.7619 20.2781 31.1577 20.2781 24.8449H17.5278V19.9262H20.2781V16.7447C20.2781 14.4661 21.3608 10.9057 26.1171 10.9057L30.4046 10.9221V15.6968C30.4046 15.6968 27.7992 15.6968 27.2927 15.6968C26.7861 15.6968 26.0659 15.9501 26.0659 17.0367V19.9272H30.4742L29.9686 24.8449Z",
    fill: "#338BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_5032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.31d32d3b315a796c1802c348f3c34f30.svg";
export { ForwardRef as ReactComponent };